<hc-modal>
    <hc-modal-header>
        <ng-content select="[modal-header]"></ng-content>
    </hc-modal-header>
    <hc-modal-body>
        <ng-content select="[modal-body]"></ng-content>
    </hc-modal-body>
    <hc-modal-footer>
        <div>
            <span *ngIf="infoTooltip" class="icon-info cdp-info-ico cdp-info-ico-left" [hcTooltip]="infoTooltip"></span>
        </div>
        <div>
            <button hc-button buttonStyle="link" (click)="cancelClicked.emit()">Cancel</button>
            <button
                hc-button
                [buttonStyle]="saveButtonStyle"
                [disabled]="disableConfirm"
                (click)="confirmClicked.emit()"
            >
                <span *ngIf="!showButtonSpinner">{{ saveButtonText }}</span>
                <span *ngIf="showButtonSpinner" class="icon-left cdp-ico-lg cdp-ico-spin icon-status-processing">
                </span>
                <div *ngIf="showButtonSpinner">{{ savingButtonText }}</div>
            </button>
        </div>
    </hc-modal-footer>
</hc-modal>
